import { SVG, SVGProps } from './svg'

export function IconClose(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22 6.5v11c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5v-11c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5zM14.7 13H2.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h12.2l-3.5-3.4a.5.5 0 010-.7L12 6a.5.5 0 01.7 0l5.2 5.2.2.5v.4c0 .2 0 .4-.2.5L12.6 18a.5.5 0 01-.7 0l-.7-.8a.5.5 0 010-.7l3.5-3.4z" />
    </SVG>
  )
}
